define('models/sidebar',['require','models/base/model','models/widgets/account','models/widgets/currency','models/widgets/manager','models/widgets/basket-count','models/widgets/multi-account'],function(require) {
    'use strict';

    var Model = require('models/base/model'),
        AccountWidget = require('models/widgets/account'),
        CurrencyWidget = require('models/widgets/currency'),
        ManagerWidget = require('models/widgets/manager'),
        BasketCountWidget = require('models/widgets/basket-count'),
        MultiAccountWidget = require('models/widgets/multi-account');

    var Sidebar = Model.extend({
        constructor: function() {
            Model.apply(this, arguments);
            this.account = new AccountWidget();
            this.currency = new CurrencyWidget();
            this.manager = new ManagerWidget();
            this.multiAccount = new MultiAccountWidget();

            this.basketCount = new BasketCountWidget();
        },
        dispose: function() {
            if (this.disposed) { return; }
            this.account.dispose();
            this.currency.dispose();
            this.manager.dispose();
            this.basketCount.dispose();
            this.multiAccount.dispose();

            Model.prototype.dispose.apply(this, arguments);
        }
    });

    return Sidebar;
});
